import { useQuery } from "@tanstack/react-query";
import { fetchPlanCatalog, fetchSubscription } from "../api/index.js";
import { queryKeys } from "../query-keys.js";

/**
 * The tiers, and the engines this server asks. It changes with a deploy or a
 * server setting, not while a page is open.
 */
export function usePlanCatalog() {
  return useQuery({
    queryKey: queryKeys.planCatalog(),
    queryFn: fetchPlanCatalog,
    staleTime: Number.POSITIVE_INFINITY,
  });
}

/** This workspace's plan: read only to know whether the workspace is closed. */
export function useSubscription(workspaceId: string) {
  return useQuery({
    queryKey: queryKeys.subscription(workspaceId),
    queryFn: () => fetchSubscription(workspaceId),
    enabled: workspaceId !== "",
  });
}
